export const GENDER_LIST_REQUEST = 'GENDER_LIST_REQUEST'
export const GENDER_LIST_SUCCESS = 'GENDER_LIST_SUCCESS'
export const GENDER_LIST_FAIL = 'GENDER_LIST_FAIL'